export const getEnv = (
	variable: string,
	defaultValue?: number | string
): any => {
	return process.env[variable] || defaultValue;
};
